import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { Observable } from 'rxjs';
import { NavigationMenu } from '../../../admin/layout/left-sidebar/left-sidebar.models';
import { AuthService } from '../../services/authentication/auth.service';
import { RefreshTokenRequestResponse, LoginResponse } from './login.models';

@Injectable()
export class LoginService
{
	constructor(private http: HttpClient, private router: Router, @Inject('BASE_URL') private baseUrl: string)
	{

	}

	// login
	login(loginViewModel): Observable<LoginResponse>
	{
		this.logout(false);

		return this.http.post<LoginResponse>(`${this.baseUrl}api/shared/auth/login`, loginViewModel);
	}

	// refresh token
	refresh(request: RefreshTokenRequestResponse): Observable<RefreshTokenRequestResponse>
	{
		return this.http.post<RefreshTokenRequestResponse>(`${this.baseUrl}api/shared/auth/refresh`, request);
	}

	// logout
	logout(redirectToLogin = true)
	{
		return this.http.post(`${this.baseUrl}api/shared/auth/logout`, {}).subscribe(() =>
		{
			// removing access_token
			AuthService.removeAccessToken();
			AuthService.removeRefresToken();

			// redirect to login
			if (redirectToLogin)
				this.router.navigate(['login']);
		});
	}

	// forgot password
	forgotPassword(email: string)
	{
		return this.http.post(`${this.baseUrl}api/shared/auth/forgotPassword`, { email: email });
	}

	// reset password
	resetPassword(userId: string, token: string, newPassword: string)
	{
		return this.http.post(`${this.baseUrl}api/shared/auth/resetPassword`, { userId: userId, token: token, password: newPassword });
	}

	// reset password (internal)
	resetPasswordInternal(userId: string, newPassword: string)
	{
		return this.http.post(`${this.baseUrl}api/shared/auth/resetPasswordInternal`, { userId: userId, password: newPassword });
	}

	// get navigation menu
	getNavigationMenu()
	{
		return this.http.get<NavigationMenu>(this.baseUrl + 'api/shared/shared/getNavigationMenu');
	}
}